import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  setItemListWrapper: {},
  programItemButton: {
    margin: theme.spacing(2, 0),
  },
  setItemListHeader: {
    minHeight: theme.spacing(5),
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(0.5, 1),
    borderRadius: '10px 10px 0 0',
    borderBottom: `1px solid ${theme.palette.border.main}`,
  },
  headerTextWrapper: {
    minWidth: 0,
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    padding: theme.spacing(0, 0.5, 0, 0),
  },
}));
